__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "comm-center";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] = scope[name] || {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "commCenter": {
			register("newReactRouterDOM", "5.1.2", () => (__webpack_require__.e(5893).then(() => (() => (__webpack_require__(68274))))));
			register("newReactRouterDOM", "6.30.6", () => (__webpack_require__.e(7349).then(() => (() => (__webpack_require__(57349))))));
		}
		break;
		case "default": {
			register("@emotion/react", "11.14.0", () => (__webpack_require__.e(4158).then(() => (() => (__webpack_require__(54158))))));
			register("@emotion/styled", "11.14.1", () => (__webpack_require__.e(8202).then(() => (() => (__webpack_require__(68202))))));
			register("@material-ui/core", "4.12.4", () => (__webpack_require__.e(2674).then(() => (() => (__webpack_require__(22674))))));
			register("@mui/icons-material", "5.18.0", () => (__webpack_require__.e(4789).then(() => (() => (__webpack_require__(24789))))));
			register("@mui/material", "5.18.0", () => (__webpack_require__.e(8274).then(() => (() => (__webpack_require__(58274))))));
			register("@tanstack/react-query-devtools", "4.44.0", () => (__webpack_require__.e(1793).then(() => (() => (__webpack_require__(31793))))));
			register("@tanstack/react-query", "4.44.0", () => (() => (__webpack_require__(25306))), 1);
			register("antd", "4.24.16", () => (__webpack_require__.e(1424).then(() => (() => (__webpack_require__(81424))))));
			register("axios", "1.20.0", () => (__webpack_require__.e(8391).then(() => (() => (__webpack_require__(772))))));
			register("classnames", "2.5.1", () => (__webpack_require__.e(6942).then(() => (() => (__webpack_require__(46942))))));
			register("dayjs", "1.11.23", () => (__webpack_require__.e(4353).then(() => (() => (__webpack_require__(74353))))));
			register("dayjs", "1.11.9", () => (__webpack_require__.e(2571).then(() => (() => (__webpack_require__(72571))))));
			register("exceljs", "4.4.0", () => (__webpack_require__.e(4974).then(() => (() => (__webpack_require__(24974))))));
			register("file-saver", "2.0.5", () => (__webpack_require__.e(4213).then(() => (() => (__webpack_require__(4213))))));
			register("history", "4.10.1", () => (__webpack_require__.e(9679).then(() => (() => (__webpack_require__(79679))))));
			register("js-file-download", "0.4.12", () => (__webpack_require__.e(5419).then(() => (() => (__webpack_require__(5419))))));
			register("jwt-encode", "1.0.1", () => (__webpack_require__.e(2382).then(() => (() => (__webpack_require__(72382))))));
			register("launchdarkly-react-client-sdk", "3.9.4", () => (__webpack_require__.e(3545).then(() => (() => (__webpack_require__(63545))))));
			register("lodash", "4.18.1", () => (__webpack_require__.e(2543).then(() => (() => (__webpack_require__(2543))))));
			register("moment", "2.31.0", () => (__webpack_require__.e(5093).then(() => (() => (__webpack_require__(95093))))));
			register("react-dom", "17.0.2", () => (() => (__webpack_require__(40961))), 1);
			register("react-spinners", "0.17.1", () => (__webpack_require__.e(9667).then(() => (() => (__webpack_require__(9667))))));
			register("react", "17.0.2", () => (() => (__webpack_require__(96540))), 1);
			register("redux-devtools-extension", "2.13.9", () => (__webpack_require__.e(9585).then(() => (() => (__webpack_require__(21966))))));
			register("redux-persist", "6.0.0", () => (__webpack_require__.e(3766).then(() => (() => (__webpack_require__(41385))))));
			register("redux-thunk", "2.4.2", () => (__webpack_require__.e(1265).then(() => (() => (__webpack_require__(1265))))));
			register("redux", "4.2.1", () => (__webpack_require__.e(2960).then(() => (() => (__webpack_require__(82960))))));
			register("semantic-ui-react", "2.1.5", () => (__webpack_require__.e(702).then(() => (() => (__webpack_require__(20702))))));
			register("styled-components", "5.3.11", () => (__webpack_require__.e(8094).then(() => (() => (__webpack_require__(78094))))));
			register("web-vitals", "2.1.4", () => (__webpack_require__.e(364).then(() => (() => (__webpack_require__(364))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};